import { CurrencyCodes } from "@doitintl/cmp-models";
import ErrorIcon from "@mui/icons-material/ErrorOutlineOutlined";
import { CircularProgress } from "@mui/material";

import { allocationTxt } from "../../../../../../assets/texts/CloudAnalytics/allocation";
import { useCustomerContext } from "../../../../../../Context/CustomerContext";
import { formatCurrency } from "../../../../../../utils/common";
import AllocationCalculationItemBox from "./AllocationCalculationItemBox";
import type ReportData from "../../../../ReportData";

type AllocationCalculationProps = {
  queryRunning: boolean;
  queryResults: ReportData | null;
  resourceName: string;
};

export const AllocationCalculation = ({ queryRunning, queryResults, resourceName }: AllocationCalculationProps) => {
  const { customer } = useCustomerContext();
  if (!queryResults && !queryRunning) {
    return;
  }
  const value = queryResults?.getRowTotals()[resourceName];
  if (queryRunning) {
    return (
      <AllocationCalculationItemBox
        icon={<CircularProgress size={20} />}
        text={allocationTxt.ALLOCATION_CALCULATION_IN_PROGRESS}
      />
    );
  }

  if (!value) {
    return (
      <AllocationCalculationItemBox
        icon={<ErrorIcon color="primary" />}
        text={allocationTxt.ALLOCATION_CALCULATION_NO_RESULTS}
      />
    );
  }

  return (
    <AllocationCalculationItemBox
      icon={<ErrorIcon color="primary" />}
      text={
        <>
          This allocation produced{" "}
          <strong>{formatCurrency(value.sum, customer.settings?.currency || CurrencyCodes.USD)}</strong> of spend over
          the last 7 days
        </>
      }
    />
  );
};
